import React, { useContext, useState, useEffect } from "react";
import classes from "./Sidebar.module.css";
import SidebarContext from "../../store/SidebarContext";
import { GiHamburgerMenu } from "react-icons/gi";
import { FaUser, FaTrophy } from "react-icons/fa";
import { MdRedeem, MdGroupAdd } from "react-icons/md";
import { SiGoogletasks } from "react-icons/si";
import { useTranslation } from "react-i18next";
import AuthContext from "../../store/AuthContext";

function Sidebar() {
  const sidebarCtx = useContext(SidebarContext);
  const [validFormIsOpen, setValidFormIsOpen] = useState(false);
  const [tg] = useTranslation("global");
  const isAuth = useContext(AuthContext).auth;

  // Detectar se é mobile para mostrar botão fixo
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= 768);
    }
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSidebarToggle = () => {
    sidebarCtx.toggleSidebar();
  };

  if (isAuth !== 2) return null;

  return (
    <>
      {/* Botão hamburger fixo só no mobile */}
      {isMobile && (
        <button
          className={classes.mobileToggle}
          onClick={handleSidebarToggle}
          aria-label="Toggle Sidebar"
        >
          <GiHamburgerMenu size={28} color="white" />
        </button>
      )}

      {/* --- Desktop & Mobile sidebar --- */}

      {sidebarCtx.sidebar ? (
        isAuth === 2 && (
          <div className={classes.sidenav_active}>
            <ul>
              <li>
                <div style={{ textAlign: "left" }}>
                  <button
                    className={`${classes.sidebarButton} ${classes.sidebarButtonToggle}`}
                    style={{
                      padding: 0,
                      border: "none",
                      background: "none",
                      display: "inline-block",
                      verticalAlign: "middle",
                      lineHeight: 0,
                      width: "auto",
                      display: "block",
                    }}
                    onClick={handleSidebarToggle}
                  >
                    <div style={{ display: "block" }}>
                      <a style={{ display: "block" }}>
                        <GiHamburgerMenu size={44} color="White" />
                      </a>
                    </div>
                  </button>
                </div>
              </li>
              <div style={{ textAlign: "left" }}>&nbsp;&nbsp;&nbsp;</div>

              <li>
                <div style={{ alignContent: "center" }}>
                  <button
                    className={classes.sidebarButton}
                    onClick={() => setValidFormIsOpen(true)}
                  >
                    <a
                      href="/verify-code"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        textDecoration: "none",
                        color: "inherit",
                      }}
                    >
                      <MdRedeem size={44} color="White" />
                      {tg("sidebar.titles.prizeValButton_active")}
                    </a>
                  </button>
                </div>
              </li>
              <li style={{ display: "flex", alignItems: "center" }}>
                <button className={classes.sidebarButton}>
                  <a
                    href="/user-stats"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textDecoration: "none",
                      color: "inherit",
                    }}
                  >
                    <FaUser size={44} color="White" />
                    {tg("sidebar.titles.userStats_active")}
                  </a>
                </button>
              </li>

              <li>
                <button className={classes.sidebarButton}>
                  <a
                    href="/prize-stats"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textDecoration: "none",
                      color: "inherit",
                    }}
                  >
                    <FaTrophy size={44} color="White" />
                    {tg("sidebar.titles.prizeStats_active")}
                  </a>
                </button>
              </li>
              <li>
                <button className={classes.sidebarButton}>
                  <a
                    href="/objective-stats"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textDecoration: "none",
                      color: "inherit",
                    }}
                  >
                    <SiGoogletasks size={44} color="White" />
                    {tg("sidebar.titles.objectiveStats_active")}
                  </a>
                </button>
              </li>

              <li>
                <button className={classes.sidebarButton}>
                  <a
                    href="/add_admin"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textDecoration: "none",
                      color: "inherit",
                    }}
                  >
                    <MdGroupAdd size={44} color="White" />
                    {tg("sidebar.titles.addAdmin_active")}
                  </a>
                </button>
              </li>
            </ul>
          </div>
        )
      ) : (
        isAuth === 2 && (
          <div className={classes.sidenav}>
            <ul>
              <li style={{ position: "sticky", top: 0, zIndex: "1000" }}>
                <div style={{ textAlign: "left" }}>
                  <button
                    className={`${classes.sidebarButton} ${classes.sidebarButtonToggle}`}
                    style={{
                      padding: 0,
                      border: "none",
                      background: "none",
                      display: "inline-block",
                      verticalAlign: "middle",
                      lineHeight: 0,
                      width: "auto",
                      display: "block",
                    }}
                    onClick={handleSidebarToggle}
                  >
                    <div style={{ display: "block" }}>
                      <a style={{ display: "block" }}>
                        <GiHamburgerMenu size={44} color="White" />
                      </a>
                    </div>
                  </button>
                </div>
              </li>
              <div style={{ textAlign: "left" }}>&nbsp;&nbsp;&nbsp;</div>
              <li>
                <div style={{ textAlign: "left", width: "46px", height: "46px" }}>
                  <button
                    className={classes.sidebarButton}
                    style={{
                      padding: 0,
                      border: "none",
                      background: "none",
                      display: "inline-block",
                      verticalAlign: "middle",
                      lineHeight: 0,
                      width: "auto",
                      display: "block",
                    }}
                    onClick={() => setValidFormIsOpen(true)}
                  >
                    <div style={{ display: "block" }}>
                      <a href="/verify-code" style={{ display: "block" }}>
                        <MdRedeem size={44} color="White" />
                      </a>
                    </div>
                  </button>
                </div>
              </li>

              <li>
                <div style={{ textAlign: "left", width: "46px", height: "46px" }}>
                  <button
                    className={classes.sidebarButton}
                    style={{
                      padding: 0,
                      border: "none",
                      background: "none",
                      display: "inline-block",
                      verticalAlign: "middle",
                      lineHeight: 0,
                      width: "auto",
                      display: "block",
                    }}
                  >
                    <a href="/user-stats" style={{ display: "block" }}>
                      <FaUser size={44} color="White" />
                    </a>
                  </button>
                </div>
              </li>

              <li>
                <div style={{ textAlign: "left", width: "46px", height: "46px" }}>
                  <button
                    className={classes.sidebarButton}
                    style={{
                      padding: 0,
                      border: "none",
                      background: "none",
                      display: "inline-block",
                      verticalAlign: "middle",
                      lineHeight: 0,
                      width: "auto",
                      display: "block",
                    }}
                  >
                    <a href="/prize-stats" style={{ display: "block" }}>
                      <FaTrophy size={44} color="White" />
                    </a>
                  </button>
                </div>
              </li>
              <li>
                <div style={{ textAlign: "left", width: "46px", height: "46px" }}>
                  <button
                    className={classes.sidebarButton}
                    style={{
                      padding: 0,
                      border: "none",
                      background: "none",
                      display: "inline-block",
                      verticalAlign: "middle",
                      lineHeight: 0,
                      width: "auto",
                      display: "block",
                    }}
                  >
                    <a href="/objective-stats" style={{ display: "block" }}>
                      <SiGoogletasks size={44} color="White" />
                    </a>
                  </button>
                </div>
              </li>

              <li>
                <div style={{ textAlign: "left", width: "46px", height: "46px" }}>
                  <button
                    className={classes.sidebarButton}
                    style={{
                      padding: 0,
                      border: "none",
                      background: "none",
                      display: "inline-block",
                      verticalAlign: "middle",
                      lineHeight: 0,
                      width: "auto",
                      display: "block",
                    }}
                  >
                    <a href="/add_admin" style={{ display: "block" }}>
                      <MdGroupAdd size={44} color="White" />
                    </a>
                  </button>
                </div>
              </li>
            </ul>
          </div>
        )
      )}
    </>
  );
}

export default Sidebar;
